'use strict';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

(function ($) {
  //Decleration of the slider
  $('.case-study-slider').flickity(_defineProperty({
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: false,
    autoPlay: false,
    fade: true,
    imagesLoaded: true,
    pauseAutoPlayOnHover: false
  }, "autoPlay", 7000));
  var $carousel = $('.case-study-slider').flickity(); //Adds functionality to the slider tabs

  $('.slider-buttons').on('click', '.slider-button', function () {
    var selector = parseInt($(this).attr('data-selector'));
    $('.slider-button').removeClass('active');
    $(this).addClass('active');
    $carousel.flickity('select', selector);
    $carousel.flickity('stopPlayer');
  });
  $('.slider-button[data-selector=0]').addClass('active'); //Active states on slider tabs

  $carousel.on('change.flickity', function (event, index) {
    $('.slider-button').removeClass('active');
    $('.slider-button[data-selector=' + index + ']').addClass('active');
  });
})(jQuery); // Fully reference jQuery after this point.
//# sourceMappingURL=block.js.map
